<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Users', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
        </v-row>

        <!-- Delete User Dialog -->
        <DeleteDialog
            :dialog.sync="deleteDialog"
            :item="deletedUser"
            v-on:confirmed="deletingConfirmed"
        >
            <template v-slot:title
                >Delete - {{ deletedUser ? deletedUser.email : "" }}</template
            >
            <template v-slot:content
                >Are you sure you want to delete this user?</template
            >
        </DeleteDialog>

        <!-- User Dialog-->
        <TenantUserEditDialog
            :object.sync="editedItem"
            :dialog.sync="userDialog"
            v-on:item-created="onUserCreated"
        ></TenantUserEditDialog>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <!-- Header -->
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="mx-2"
                                    >group</v-icon
                                >Users
                                <v-spacer></v-spacer>
                                <v-btn
                                    v-if="hasPermission('add_customuser')"
                                    color="primary"
                                    dark
                                    outlined
                                    rounded
                                    small
                                    @click="addUser"
                                    >New User</v-btn
                                >
                            </v-card-title>

                            <!-- User table -->
                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries.tenantUsers.loading
                                    "
                                    :items="tenantUsers.edges"
                                    :itemsPerPage="itemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ]
                                    }"
                                    sortBy="node.email"
                                    loading-text="Loading... Please wait"
                                >
                                    <template
                                        v-slot:item.node.tenantUser.isAdmin="{
                                            item
                                        }"
                                    >
                                        <v-icon
                                            v-if="item.node.tenantUser.isAdmin"
                                            color="success"
                                            >check_circle</v-icon
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.groups.totalCount="{
                                            item
                                        }"
                                    >
                                        <span
                                            v-if="
                                                item.node.groups.totalCount == 0
                                            "
                                            class="error--text"
                                            >{{
                                                item.node.groups.totalCount
                                            }}</span
                                        >
                                        <span v-else>{{
                                            item.node.groups.totalCount
                                        }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-btn
                                            :disabled="
                                                !hasPermission(
                                                    'change_customuser'
                                                )
                                            "
                                            icon
                                            outlined
                                            small
                                            color="primary"
                                            class="mr-2"
                                            @click="editUser(item.node)"
                                        >
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                        <v-btn
                                            :disabled="
                                                !hasPermission(
                                                    'delete_customuser'
                                                )
                                            "
                                            icon
                                            outlined
                                            small
                                            color="error"
                                            @click="deletingUser(item.node)"
                                        >
                                            <v-icon small>delete</v-icon>
                                        </v-btn>
                                        <!-- <v-icon small @click="deletingPlant(item)">delete</v-icon> -->
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import DeleteDialog from "@/components/base/DeleteDialog.vue";
import TenantUserEditDialog from "@/components/users/TenantUserEditDialog.vue";

export default {
    name: "tenant-user-list-page",
    components: {
        TenantUserEditDialog,
        DeleteDialog
    },

    apollo: {
        tenantUsers: {
            query: gql`
                query tenantUsers(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                ) {
                    tenantUsers(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                email
                                firstName
                                lastName
                                tenantUser {
                                    id
                                    isAdmin
                                }
                                groups {
                                    totalCount
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: (data) => data.tenantUsers,
            // skip: true,
            pollInterval: 60000 // ms
        }
    },

    data: function () {
        return {
            userDialog: false,
            deleteDialog: false,

            tenantUsers: {},

            itemsPerPage: 25,
            search: "",

            editedItem: null,
            defaultItem: {
                id: null,
                email: null,
                firstName: null,
                lastName: null,
                isAdmin: false
            },

            deletedUser: {},

            headers: [
                {
                    text: "Email",
                    value: "node.email",
                    sortable: true
                },
                {
                    text: "First Name",
                    value: "node.firstName",
                    sortable: true
                },
                {
                    text: "Last Name",
                    value: "node.lastName",
                    sortable: true
                },
                {
                    text: "Administrator",
                    value: "node.tenantUser.isAdmin",
                    sortable: true
                },
                {
                    text: "#Groups",
                    value: "node.groups.totalCount",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {},
    watch: {},
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {},
    methods: {
        onUserCreated() {
            this.userDialog = false;
            this.$apollo.queries.tenantUsers.refresh();
        },

        addUser() {
            this.editedItem = null;
            this.userDialog = true;
        },

        editUser(user) {
            this.editedItem = JSON.parse(JSON.stringify(user));

            this.editedItem.isAdmin = this.editedItem.tenantUser.isAdmin;

            this.userDialog = true;
        },

        deletingUser(item) {
            this.deletedUser = item;
            this.deleteDialog = true;
        },

        deletingConfirmed(item) {
            if (item) {
                const payload = {
                    id: item.id
                };

                this.$store
                    .dispatch("user/deleteUser", payload)
                    .then((response) => {
                        // refresh plants
                        this.$apollo.queries.tenantUsers.refresh();

                        // close delete dialog
                        this.deleteDialog = false;

                        // show snackbar
                        const payload = {
                            color: "success",
                            message: `${response.email} is deleted!`
                        };
                        this.$store.dispatch("snackbar/showMessage", payload);
                    })
                    .catch((error) => {
                        this.error = error.graphQLErrors[0].message;
                    });
            }
        }
    }
};
</script>